import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'nx-card-item',
  templateUrl: './nx-card-item.component.html',
  styleUrls: ['./nx-card-item.component.scss']
})
export class NxCardItemComponent implements OnInit {
  @Input() data: any;
  @Input() language: boolean;
  @Input() screen: string;

  border: boolean = false;
  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    if (this.data.limited == true) {this.border = true};
    if (this.data.new == true) {this.border = true};
    // this.getBackgroundImage();
  }

//   getBackgroundImage(): SafeStyle {
//   const url = this.data.image; // Link from Firestore
//   return this.sanitizer.bypassSecurityTrustStyle(`url(${url})`);
// }

}
